import React from "react";
import { Box, Typography } from "@mui/material";
import {
  AutoStoriesOutlined,
  VideocamOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";

const EmptyState = ({
  type = "stories",
  title,
  description = "No items are available right now. Please check back later.",
  showIcon = true
}) => {
  // Configuration for different content types
  const getConfig = (contentType) => {
    switch (contentType.toLowerCase()) {
      case "stories":
        return {
          icon: AutoStoriesOutlined,
          backgroundColor: "#E1F5FE",
          borderColor: "#01579B",
          iconColor: "#01579B",
          defaultTitle: "No Stories Available",
        };
      case "videos":
        return {
          icon: VideocamOutlined,
          backgroundColor: "#FCF2E3",
          borderColor: "#EFB561",
          iconColor: "#EFB561",
          defaultTitle: "No Videos Available",
        };
      case "listings":
        return {
          icon: ShoppingCartOutlined,
          backgroundColor: "#FFF1F4",
          borderColor: "#EF5658",
          iconColor: "#EF5658",
          defaultTitle: "No Listings Available",
        };
      case "followers":
        return {
          defaultTitle: "No Followers Available",
        };
      case "following":
        return {
          defaultTitle: "No Following Available",
        };
      case "ratings":
        return {
          defaultTitle: "No Ratings Available",
        };
      default:
        return {
          icon: AutoStoriesOutlined,
          backgroundColor: "#E1F5FE",
          borderColor: "#01579B",
          iconColor: "#01579B",
          defaultTitle: "No Items Available",
        };
    }
  };

  const config = getConfig(type);
  const IconComponent = config.icon;
  const displayTitle = title || config.defaultTitle;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 4,
        textAlign: "center",
        backgroundColor: "white",
      }}
    >
      {showIcon && IconComponent && (
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            backgroundColor: config.backgroundColor,
            border: `4px solid ${config.borderColor}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <IconComponent
            sx={{
              fontSize: 24,
              color: config.iconColor,
            }}
          />
        </Box>
      )}
      <Typography
        variant="h6"
        sx={{
          fontWeight: "600",
          color: "#333",
          fontSize: "14px",
          mb: 0.5,
        }}
      >
        {displayTitle}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "#666",
          fontSize: "14px",
          maxWidth: "400px",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyState;
